import {
  getPeronsDatas,
  getPeronListsDatas,
  getTeamPersonList,
  subQuitForm,
  quitFilter,
  getFilterListsDatas,
  getMenuList
} from '@/services/quit'
import { fetchClueQuitData, clueQuithandover } from '@/services/clue'
import _ from 'lodash'
import { toType } from '@/lib/utils'
export default {
  namespaced: true,
  state: {
    personsList: [],
    quitListDatas: {},
    filterResult: [],
    datasReady: false,
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 30, 50, 100, 200],
      total: 0
    },
    menuList: [],
    loading: false,
    quitName: {},
    selectList: [],
    listShow: false
  },
  mutations: {
    setPersonsList (state, data) {
      state.personsList = data
    },
    setQuitListDatas (state, data) {
      state.quitListDatas = data
    },
    setquitName (state, data) {
      state.quitName = data
    },
    setSelectList (state, datas) {
      state.selectList = datas
    },
    setFilterResult (state, datas) {
      state.filterResult = datas
    },
    setPageTotal (state, data) {
      state.pagination.total = data
    },
    setListShow (state, b) {
      state.listShow = b
    },
    setMenuList (state, data) {
      state.menuList = data
    },
    setDatasReady (state, b) {
      state.datasReady = b
    }
  },
  getters: {
    columnsT (state) {
      const arr = []
      if (state.quitListDatas.title) {
        for (let [key, value] of Object.entries(state.quitListDatas.title)) {
          const item = {
            title: value,
            dataIndex: key,
            key: key,
            scopedSlots: { customRender: key },
            width: key === 'base_info_info_type' || key === 'base_info_info_status' ? 90 : 'auto'
          }
          arr.push(item)
        }
      } else {
      }
      return arr
    },
    dataList (state, commit) {
      const { quitListDatas = {} } = state
      const { data = {} } = quitListDatas
      const { list = [] } = data
      let datas = _.cloneDeep(list)
      datas.forEach(item => {
        item['key'] = item.inquiryid || item.id
        for (let k in item) {
          if (item.inquiryid && !item[k].columntype) {
            if (toType(item[k]) === 'object') {
              if (item[k].fieldvalue === '') {
                item[k] = '- -'
              } else {
                item[k] = item[k].fieldvalue
              }
            }
          }
        }
      })
      // state.datasReady = true
      return datas
    }
  },
  actions: {
    // 获取具有对应权限的人员列表
    async getPeronsDatas ({ commit }) {
      const chain = await getPeronsDatas()
        .onSuccess(raw => {
          commit('setPersonsList', raw.list)
        })
        .config({
          tip: false
        })
      return chain
    },
    // 获取具有对应权限的人员列表
    async getMenuList ({ commit }) {
      const chain = await getMenuList()
        .onSuccess(raw => {
          commit('setMenuList', raw)
        })
        .config({
          tip: false
        })
      return chain
    },
    // 获取人员列表
    async getPeronListsDatas ({ commit }, data) {
      let chain = null
      commit('setDatasReady', false)
      if (data.isFilter) {
        chain = await getFilterListsDatas()
      } else {
        chain = data.isClue ? await fetchClueQuitData() : await getPeronListsDatas()
      }
      chain
        .onSuccess(raw => {
          let obj = {}
          if (data.isClue) {
            obj.data = {
              count: raw.count,
              list: raw.list
            }
            obj.title = raw.title
          } else {
            obj = raw
          }
          commit('setQuitListDatas', obj)
          // commit('setDatasReady', true)
          commit('setPageTotal', parseInt(obj.data.count))
          commit('setDatasReady', true)
          commit('setFilterResult', [])
        })
        .config({
          tip: false
        })
      return chain
    },
    // 获取具有对应权限的团队组人
    async getTeamPersonList ({ commit }) {
      const chain = await getTeamPersonList()
        .onSuccess(raw => {
          commit('setSelectList', raw)
        })
        .config({
          tip: false
        })
      return chain
    },
    // 离职交接获取筛选数据
    async quitFilterDatas ({ state, commit }) {
      const chain = await quitFilter()
        .onSuccess(raw => {
          if (!state.filterResult.length) {
            commit('setFilterResult', raw)
          }
        })
        .config({
          tip: false
        })
      return chain
    },
    // 交接
    async subQuitForm ({ commit, dispatch }, data) {
      const chain = data.isClue ? await clueQuithandover() : await subQuitForm()
        .onSuccess(raw => {
          // const chain = dispatch('getPeronListsDatas', userid)
          // chain.fetch()
        })
        .config({
          tip: false
        })
      return chain
    }
  }
}
